import { coloredSectionProps } from "./LinearGaugeComponents/ColoredSectionLinearGauge";

export const handlePointerPosition = (value: number, sumOfRange: number, rangeStart: number): string => {
    const distanceFromRangeStart = value - rangeStart;
    const percentageFromRange = (distanceFromRangeStart / sumOfRange) * 100;

    if (percentageFromRange >= 100) return '100';
    if (percentageFromRange <= 0) return '0';
    return percentageFromRange.toFixed(2);
};
export const calculateAreaPercentage = (sumOfRange: number, rangeStart: number, rangeEnd: number): string => {
    return (((rangeEnd - rangeStart) / sumOfRange) * 100).toFixed(2);
};
export const formatAreaToToolTipText = (area: { start: number; end: number; }): string => {
    return `$ ${area.start.toLocaleString()} - $${area.end.toLocaleString()}`;
};




export const generateColoredAreaData = (
    colors: string[],
    isRounded: boolean,
    toolTipTexts: {
        dangerMinText: string;
        possibleMinText: string;
        optimalText: string;
        possibleMaxText: string;
        dangerMaxText: string;
    },
    calculations: {
        dangerLeftArea: string;
        possibleLeftArea: string;
        optimalArea: string;
        possibleRightArea: string;
        dangerRightArea: string;
    }
): coloredSectionProps[] => {
    return [
        {
            color: colors[0],
            isRounded: isRounded,
            toolTipText: toolTipTexts.dangerMinText,
            widthInPrec: calculations.dangerLeftArea,
            isFirst: true, // Assuming this is the first element in the visual representation
            isLast: false,
        },
        {
            color: colors[1],
            isRounded: isRounded,
            toolTipText: toolTipTexts.possibleMinText,
            widthInPrec: calculations.possibleLeftArea,
            isFirst: false,
            isLast: false,
        },
        {
            color: colors[2],
            isRounded: isRounded,
            toolTipText: toolTipTexts.optimalText,
            widthInPrec: calculations.optimalArea,
            isFirst: false,
            isLast: false,
        },
        {
            color: colors[1],
            isRounded: isRounded,
            toolTipText: toolTipTexts.possibleMaxText,
            widthInPrec: calculations.possibleRightArea,
            isFirst: false,
            isLast: false,
        },
        {
            color: colors[0],
            isRounded: isRounded,
            toolTipText: toolTipTexts.dangerMaxText,
            widthInPrec: calculations.dangerRightArea,
            isFirst: false,
            isLast: true,
        },
    ];
};